import React from "react"


export const Courses = () => (
    <div className="col-md-3 m-auto h-50">
        <div className="card">
            <img src="./img/barista-course.jpg" className="card-img-top" alt="..."/>
            <div className="card-img-overlay">
                <h5 className="card-title"></h5>
                <div className="card-footer text-center">
                    <h4>
                    Inmersion
                    </h4>
                    <h6>
                    Immersion is an online coffee course that explores 
                    the best techniques and recipes for immersion brew methods. 
                    Immersion brew methods vary greatly from one to the next and in this ambitious course, 
                    we look at everything, 
                    from French press and Aeropress, to syphon coffee …
                    </h6>
                </div>
            </div>
        </div>
    </div>)
    